<template>
  <v-app>
    <dashboard-core-app-bar />

    <dashboard-core-drawer />

    <dashboard-core-view />

    <dashboard-core-settings v-if="false" />
  </v-app>
</template>

<script>
export default {
  name: "DashboardIndex",
  components: {
    DashboardCoreAppBar: () => import("./components/core/AppBar"),
    DashboardCoreDrawer: () => import("./components/core/Drawer"),
    DashboardCoreSettings: () => import("./components/core/Settings"),
    DashboardCoreView: () => import("./components/core/View"),
  },
  data() {
    return {
      expandOnHover: false,
    };
  },
  created() {
    this.setHost();
    this.setLanguage();
    this.setWithDash();
  },
  methods: {
    setHost() {
      let ip = window.location.hostname;
      let port = window.location.port;

      this.$store.state.host.ip = ip;
      this.$store.state.host.port = port == "" ? 80 : port;
    },
    setLanguage() {
      let lang = "en";

      if (window.localStorage.getItem("lang") != null) {
        lang = window.localStorage.getItem("lang");
      } else {
        if (navigator.language == "en-US" || navigator.language == "en") {
          lang = "en";
        } else if (navigator.language == "zh-TW") {
          lang = "tw";
        }
      }
      this.$store.dispatch("setLanguage", lang);
    },
    setWithDash() {
      let withDash = true;

      if (window.localStorage.getItem("withDash") != null) {
        withDash = window.localStorage.getItem("withDash") === "true";
      }

      this.$store.dispatch("setWithDash", withDash);
      window.localStorage.setItem("withDash", this.$store.state.withDash);
    },
  },
};
</script>
